import React from "react";

interface WarningProps {
  color?: string;
  size?: number;
  filled?: boolean;
}

export const Warning = ({ color = "#FCB041", size = 40, filled = false }: WarningProps) => {
  const symbolColor = filled ? "white" : color;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.04595 28.2827L17.9447 9.56971C18.1424 9.19601 18.4382 8.88328 18.8004 8.66516C19.1626 8.44704 19.5774 8.33179 20.0002 8.33179C20.423 8.33179 20.8377 8.44704 21.1999 8.66516C21.5621 8.88328 21.858 9.19601 22.0557 9.56971L31.9544 28.2827C32.1402 28.6358 32.2314 29.0311 32.219 29.4299C32.2066 29.8288 32.0911 30.2176 31.8838 30.5585C31.6764 30.8995 31.3843 31.1809 31.0359 31.3753C30.6874 31.5698 30.2946 31.6707 29.8955 31.6682H10.1004C9.70171 31.6699 9.30939 31.5685 8.96157 31.3737C8.61374 31.1789 8.32224 30.8974 8.11543 30.5566C7.90862 30.2158 7.79353 29.8273 7.78135 29.4288C7.76918 29.0303 7.86033 28.6355 8.04595 28.2827Z"
        fill={filled ? color : "none"}
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.998 16.1129V22.7795"
        stroke={symbolColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.998 25.5017C20.6422 25.5019 21.1641 26.0245 21.1641 26.6687C21.1639 27.3127 20.6421 27.8345 19.998 27.8347C19.3539 27.8347 18.8312 27.3128 18.8311 26.6687C18.8311 26.0244 19.3537 25.5017 19.998 25.5017Z"
        fill={symbolColor}
        stroke={symbolColor}
      />
    </svg>
  );
};
